type IUser = {
  firstName?: string;
  lastName?: string;
};

export const getFullName = (user?: IUser): string => {
  if (!user?.firstName && !user?.lastName) return '';
  return `${user?.firstName || ''} ${user?.lastName || ''}`;
};
